import { KnaufPlaster } from './knauf-plaster.enum';
import { KnaufSellerLocation } from './knauf-sellers-locations';
import { KnaufMosaicColor } from './knauf-mosaic-color';
import { KnaufColor } from './knauf-color';
import { Project, ProjectType } from './project';
import { Injectable } from '@angular/core';
import { KnaufPalettes } from './knauf-palettes.enum';
import { Izolacja, MaterialBudowlany, Otoczenie, EfektDekoracyjny, Odpornosc, Ankieta } from './ankieta';
import { Layer } from './layer';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  private project: Project = new Project();
  constructor() {
    if (localStorage.getItem('project') === null) {
      this.project = new Project;
    } else {
      this.project = JSON.parse(localStorage.getItem('project'));
      this.project.ankieta = new Ankieta().deserialize(this.project.ankieta);
    }
  }

  getProject(): Project {
    return this.project;
  }

  setProject(project: Project) {
    this.project = project;
  }

  resetProject() {
    this.project = new Project;
  }

  private saveProject() {
    localStorage.setItem('project', JSON.stringify(this.project));
  }
  setSelectedColors(colors: KnaufColor[]) {
    this.project.selectedColors = colors;
    this.saveProject();
  }
  setSelectedMosaic(mosaic: KnaufMosaicColor) {
    this.project.selectedMosaic = mosaic;
    this.saveProject();
  }
  setKnaufPalette(palette: KnaufPalettes) {
    this.project.knaufPalette = palette;
    this.saveProject();
  }
  setProjectType(type: ProjectType) {
    this.project.projectType = type;
    this.saveProject();
  }
  setProjectImageFile(filename: string) {
    this.project.projectImageFile = filename;
    this.saveProject();
  }
  setOrgImageFile(file: string) {
    this.project.orgImageFile = file;
    this.saveProject();
  }
  setAnkietaPytanie1a(odp: Izolacja) {
    this.project.ankieta.pytanie1a = odp;
    this.saveProject();
  }
  setAnkietaPytanie1b(odp: MaterialBudowlany) {
    this.project.ankieta.pytanie1b = odp;
    this.saveProject();
  }
  setAnkietaPytanie2(odp: Otoczenie) {
    this.project.ankieta.pytanie2 = odp;
    this.saveProject();
  }
  setAnkietaPytanie3(odp: EfektDekoracyjny) {
    this.project.ankieta.pytanie3 = odp;
    this.saveProject();
  }
  setAnkietaPytanie4(odp: Odpornosc) {
    this.project.ankieta.pytanie4 = odp;
    this.saveProject();
  }

  setCalculatorPlaster(meters: string, gramatura: number, buckets: number) {
    this.project.calculator.plaster.meters = meters;
    this.project.calculator.plaster.gramatura = gramatura;
    this.project.calculator.plaster.buckets = buckets;
    this.saveProject();
  }
  setCalculatorMosaic(meters: string, gramatura: number, buckets: number) {
    this.project.calculator.mosaic.meters = meters;
    this.project.calculator.mosaic.gramatura = gramatura;
    this.project.calculator.mosaic.buckets = buckets;
    this.saveProject();
  }
  setClosestSellers(sellers: KnaufSellerLocation[]) {
    this.project.closestSellers = sellers;
    this.saveProject();
  }
  selectKnaufPlaster(knaufPlaster: KnaufPlaster) {
    this.project.selectedKanufPlaster = knaufPlaster;
    this.saveProject();
  }

  setLayers(layers: Layer[]) {
    this.project.layers = layers;
    this.setSelectedColors(this.getLayersColors(layers));
  }

  getLayersColors(layers: Layer[]): KnaufColor[] {
    var selectedColors: KnaufColor[] = [];
    for (let layer of layers) {
      var isNew: boolean = true;
      for (let color of selectedColors) {
        if (color.code == layer.color.code) {
          isNew = false;
        }
      }
      if (isNew && layer.color) {
        selectedColors.push(layer.color);
      }
    }
    return selectedColors;
  }

  getSelectedKnaufPlaster(): KnaufPlaster {
    return this.project.selectedKanufPlaster != KnaufPlaster.invalid ? this.project.selectedKanufPlaster : this.project.ankieta.getSelectedKnaufPlaster();
  }
}
